import React, { useEffect, useState } from 'react';
import { Widget, addResponseMessage, toggleMsgLoader, setQuickButtons, addUserMessage, toggleWidget } from 'react-chat-widget';
import 'firebase/firestore';
import './App.css';
import './styles.css';
import './lily_styles.css';


function App() {
  const [widgetParams, setWidgetParams] = useState({});
  const urlParams = new URLSearchParams(window.location.search);
  const businessId = urlParams.get('businessId');
  const [errorMessage, setErrorMessage] = useState(null);
  const [uid, setUid] = useState(null);
  const [currentResponse, setCurrentResponse] = useState('');
  const [chatHistory, setHistory] = useState(null);
  const [toggleClicked, setToggle] = useState(false);

  const handleNewUserMessage = (newMessage) => {
    sendPostRequest(newMessage);
  };

  const handleQuickButtonClicked = (button) => {
  // button contains the value of the quick reply button clicked
   console.log(button);
   window.parent.postMessage({ action: "loadSupport", humanChat:true  }, '*');
  // You can send a message using the button value or perform other actions
  sendToAnalytics("loadSupport clicked"); 
  addResponseMessage(`You clicked: ${button.label}`);
  };

  const handleToggle = (isOpen) => {
    const newHeight = isOpen ? "80vh" : "100px";
    const newWidth = isOpen? "30vw": "100px";
    setToggle(true);
  //  sendToAnalytics("chatwidget toggle clicked");
    window.parent.postMessage({ action: "resize", iframeHeight: newHeight, iframeWidth:newWidth }, '*');
  };

  const sendToAnalytics = (message) => {
    fetch('https://deeoe4fgji.execute-api.us-east-2.amazonaws.com/default/salesAgentDataCollection', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ChatMessage: message, SessionId: uid, businessId: businessId }),
    })
    .catch(err => console.error("Analytics Error:", err));
  };

  useEffect(() => {
  const handleParentMessage = (event) => {
    console.log("Setting the sessionid", event.data.sessionId);
    console.log(event.data);

    // Handling the case when the type is not 'toggleOn'
    if (event.data && event.data.sessionId && event.data.sessionId !== uid && event.data.sessionId !== null && event.data.type !== "toggleOn") {
      console.log("Setting the sessionid", event.data.sessionId);
      var history = event.data.chatLog;
      setHistory(history);
      setUid(event.data.sessionId);
      console.log("Chat logs", event.data.chatLog);

      if (history.length === 0) {
        console.log("History is empty");
        // sendPostRequest("hi");
      } else if (history) {
        let isFirstUserMessage = true;
        history.forEach(msg => {
          // Check if the message property exists and handle different property name cases
          const messageText = msg.message || msg.Message;

          if (messageText) {
            // Process each message and add it to the chat widget
            if (messageText.startsWith('HumanMessage:')) {
              if (isFirstUserMessage) {
                // Skip the first user message and update the flag
                isFirstUserMessage = false;
              } else {
                // Process and add subsequent user messages
                const userMessage = messageText.replace('HumanMessage:', '').trim();
                addUserMessage(userMessage);
              }
            } else if (messageText.startsWith('AIMessage:')) {

              const agentMessage = messageText.replace('AIMessage:', '').trim();
              addResponseMessage(agentMessage);
            }
          }
        });
        window.parent.postMessage({ status: "Session ID updated", sessionId: event.data.sessionId }, '*');
	var cleanedmsg = history[1].message.replace("AIMessage:","").trim();
	window.parent.postMessage({ action: "addOverlay", response: cleanedmsg }, '*');
      }
    } 
    // New conditional block for handling 'toggleOn' event
    else if (event.data && event.data.sessionId && event.data.sessionId !== uid && event.data.sessionId !== null && event.data.type === "toggleOn") {
      console.log("Toggle was clicked");
       toggleWidget();
      const newHeight = "80vh" ;
      const newWidth = "30vw";
          window.parent.postMessage({ action: "resize", iframeHeight: newHeight, iframeWidth:newWidth }, '*');
      // Additional logic for handling 'toggleOn' can be added here if necessary
    }
  };

  window.addEventListener('message', handleParentMessage);
  return () => {
    window.removeEventListener('message', handleParentMessage);
  };
}, []);
useEffect(() => {
  setQuickButtons([{ label: 'Chat with a Human', value: 'look-up-order' }]);
  if (uid) {
    console.log("UID updated to:", uid);
   if (chatHistory.length === 0) {
        console.log("History is empty Gotta say hi!");
	 sendPostRequest("hi-event");
	 addResponseMessage("Responses are being used for research [purposes](https://t.ly/eHItS)");
         //sendPostRequest("hi");

     }

      const timer = setTimeout(() => {
      console.log("This runs after a timeout");
      addResponseMessage("Thank you for participating in our [study](https://milwaukee.qualtrics.com/jfe/form/SV_8q9wnCbUTraOmay?receipientId="+uid+")");
     }, 900000);
    // Call sendPostRequest or any other method that depends on the updated uid
    //sendPostRequest("hi");
  }
}, [uid]); // Separate useEffect that depends on uid




 const fetchAndProcessStream = async (message) => {
    toggleMsgLoader();
    try {
      const response = await fetch('https://my-sales-agent.com/stream', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: message, conv_id: uid, businessId }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const reader = response.body.getReader();
      var completeResult = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        let chunk = new TextDecoder("utf-8").decode(value);
        completeResult += chunk;
      }

      // Assuming completeResult now contains the full response
      completeResult = processResponse(completeResult);
      console.log(completeResult);
      addResponseMessage(completeResult);
      
    } catch (error) {
      console.error('Fetch error:', error);
      addResponseMessage(`Error: ${error.message}`);
      sendToAnalytics("Error Occured");
    } finally {
      toggleMsgLoader();
      console.log("This is the add overlay");
      console.log(completeResult);
      window.parent.postMessage({ action: "addOverlay", response:completeResult }, '*');
    }
  };

  const processResponse = (response) => {
    // Process the response as needed
   //return response.replace("response:","");
   //return response.replace(/response:/gi, "").replace(/\r?\n|\r/g, "").trim();
    response =  response.replace("response:","");
    return response.replace(/\r?\n|\r/g, "").trim();
  };

 const sendPostRequest = async (message, retryCount = 0) => {
  const maxRetries = 5; // Maximum number of retries
  const retryDelay = 2000; // Delay between retries in milliseconds

  // Retry function
  const retrySending = () => {
    console.log(`Retrying... Attempt ${retryCount + 1}`);
    setTimeout(() => sendPostRequest(message, retryCount + 1), retryDelay);
  };

  // Check if uid is set
  /*if (!uid) {
    if (retryCount >= maxRetries) {
      console.error("Maximum retries reached. UID not set.");
      setErrorMessage("Failed to send message. Session ID not available.");
      return;
    }
    console.log("Session ID (uid) is not set. Waiting to retry...");
    retrySending();
    return;
  }*/
   fetchAndProcessStream(message);

};

  return (
    <div className="App chat-widget-container">
      
        <Widget
          handleNewUserMessage={handleNewUserMessage}
	  handleQuickButtonClicked={handleQuickButtonClicked}
          profileAvatar={widgetParams.logo}
	  launcherOpenImg={"https://paintbyai.s3.amazonaws.com/Logo.png"}
          title={""}
	  titleAvatar={"https://paintbyai.s3.amazonaws.com/Logo_Header.png"}
          subtitle={" "}
          handleToggle={handleToggle}
        />
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
}

export default App;

